import { useEffect } from 'react';
import { ERROR_PREFIXES } from 'src/common/constants';
import { PossibleZillowSession } from '../../../types';

export class RefreshTokenError extends Error {
    type = 'RefreshTokenError';
    constructor(errorMessage: string) {
        const prefixedMessage = `${ERROR_PREFIXES.OAUTH} ${errorMessage}`;
        super(prefixedMessage);
        this.type = 'RefreshTokenError';
        this.name = 'RefreshTokenError';
        this.message = prefixedMessage;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any).__proto__ = RefreshTokenError.prototype;
    }
}
export const useLogReportedRefreshError = (session: PossibleZillowSession) => {
    useEffect(() => {
        const logDatadog = async () => {
            if (session?.error) {
                const { datadog } = await import(
                    /* webpackChunkName: "datadog" */
                    'src/services/datadog'
                );
                datadog.addError(new RefreshTokenError('Session refresh failed'), {
                    cause: session.error,
                });
            }
        };
        logDatadog();
    }, [session?.error]);
};
